import { LEGAL_UI } from '../legal/content'
import Seo from './Seo'
import { L, useLocale } from '../i18n/locale.jsx'
import { getSeo } from '../i18n/seo'

// Pagină legală (Privacy / Terms / Imprint). Conținut RO/EN/DE portat din vorba.dev.
export default function LegalPage({ content, titleKey }) {
  const locale = useLocale()
  const sections = content[locale] || content.en
  const ui = LEGAL_UI[locale] || LEGAL_UI.en
  const heading = ui[titleKey]

  return (
    <>
      <Seo title={`${heading} — vorba.dev`} description={getSeo(locale).legalDescription(heading)} />
      <section data-theme="light" className="min-h-screen px-5 pb-32 pt-32 text-ink md:px-10">
        <div className="mx-auto max-w-3xl">
          <L
            to="/"
            className="eyebrow inline-flex min-h-[44px] items-center transition-colors duration-300 ease-quint hover:text-honey-deep"
          >
            {ui.back}
          </L>

          <h1 className="display mt-8 text-4xl leading-[1.05] md:text-5xl">{heading}</h1>
          <p className="mt-4 max-w-[60ch] font-mono text-[12px] leading-relaxed text-ink-soft">{ui.disclaimer}</p>

          <div className="mt-12 space-y-10">
            {sections.map((s, i) => (
              <div key={i}>
                <h2 className="display-italic text-2xl leading-tight text-ink md:text-[26px]">{s.heading}</h2>
                <div
                  className="legal-body mt-3 max-w-[68ch] text-[15px] leading-relaxed text-ink-soft"
                  dangerouslySetInnerHTML={{ __html: s.body }}
                />
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
